import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { getApiUrl } from '../../core/helpers/rest-utils';
import { formatPhoneNumber } from '../../core/helpers/utils';

@Injectable({ providedIn: 'root' })
export class PhoneNumberValidator implements AsyncValidator {
    constructor(private http: HttpClient) { }

    validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value) {
            return of(null);
        }
        return of(control.value).pipe(
            debounceTime(300),
            switchMap(n => {
                const number = formatPhoneNumber(n);
                return this.http.post(`${getApiUrl()}validate/phone-number`, { number }).pipe(
                    map((response: any) => response?.data?.valid ? null : { serverValidation: true }),
                    catchError((error) => {
                        console.error('Phone validation error:', error);
                        return of(null);
                    }))
            })
        );
    }
}
